<template>
  <Modal
    name="INSTALLMENTS_MODAL"
    width="450"
    :title="$t('quote.modal.availableInstallments')"
  >
    <template v-slot:body>
      <p class="caption">
        {{ $t('quote.modal.availableInstallmentsDescription') }}
      </p>

      <v-simple-table dense>
        <thead>
          <tr>
            <td class="caption font-weight-bold">
              {{ $t('quote.modal.installmentTerm') }}
            </td>
            <td class="caption text-right font-weight-bold">
              {{ $t('quote.modal.installmentMonthlyValue') }}
            </td>
            <td class="caption text-right font-weight-bold">
              {{ $t('quote.modal.installmentTotalValue') }}
            </td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in creditCardDataInstallments" :key="item.installment_amount">
            <td class="caption">
              {{ item.installment_amount }}x
            </td>
            <td class="caption text-right">
              {{ item.installment_value ? formatMoney(item.installment_value) : '---' }}
            </td>
            <td class="caption text-right">
              {{ item.total_value ? formatMoney( item.total_value) : '---' }}
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/app/Modal'
import { catalogMonetary } from '@/util/catalog'

export default {
  components: {
    Modal,
  },

  props: {
    quoteItems: {
      type: Object,
      required: true,
    }
  },

  computed: {
    creditCardDataInstallments() {
      if (this.quoteItems?.payment_options.length <= 0) return
      return this.quoteItems?.payment_options
        .filter(({ payment_method }) => payment_method === 'ASAAS_CREDIT_CARD')
        .reverse()
    },
  },

  data() {
    return {
      formatMoney: catalogMonetary,
    }
  },
}
</script>
